import Suffix from "./Suffix";

export default class RibbonList {
  constructor(container) {
    if (!container) return;

    this.container = container;

    this.container.parentElement.addEventListener(
      "ItemNumber.change",
      this.itemNumberChange
    );
  }

  get quantityRibbon() {
    return this.container.querySelector(".ribbon--quantity") || {};
  }

  get shippingRibbon() {
    return this.container.querySelector(".ribbon--shipping") || {};
  }

  get mixAndMatchRibbon() {
    return (
      this.container.querySelector(".suffixMixAndMatch") || { dataset: {} }
    );
  }

  itemNumberChange = (event) => {
    const itemNumber = event.detail;
    const item = Suffix.priceLookup(itemNumber);

    this.mixAndMatchRibbon.hidden = !(
      this.mixAndMatchRibbon.dataset.itemNumber === itemNumber.toString()
    );

    const shipping = Suffix.shippingLookup(itemNumber);

    this.shippingRibbon.hidden = !(
      shipping.freeShipping || window.freeShippingCheck
    );

    this.quantityRibbon.hidden = !item.showQtyDiscountRibbon;
  };
}
